import Paper from '@mui/material/Paper';
import { makeStyles, withStyles } from 'utils/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { isNil, sortBy } from 'lodash';
import React from 'react';
import theme from 'source/theme';
import { orderKeys } from 'utils/tables/order';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.primary.light,
    paddingLeft: 75
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const useStyles = makeStyles({
  title: {
    backgroundColor: theme.palette.background.veryLight,
    padding: '7px 0px 7px 16px',
    flex: '1 1 100%'
  }
});

export default props => {
  const { columns, order, rows, title } = props;
  const classes = useStyles();

  // The columns' own fields, in the order they are read. Sufficient by
  // construction: what a row draws is a function of those fields, so two rows
  // this leaves tied draw the same text and their order cannot be seen. The
  // exception is a `render` that reaches for a field of its own choosing -
  // `SubstanceProvenanceDetailPanel` is the only one - and that panel names its
  // fields through `order` instead.
  const orderedRows = sortBy(
    rows, orderKeys((order || columns.map(c => c.field)).filter(field => !isNil(field)))
  );

  return (
    <TableContainer component={Paper}>
      {
        title &&
        <Typography className={classes.title} variant="h6" id="tableTitle">
          {title}
        </Typography>
      }
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            {columns.map(column =>
              <StyledTableCell key={column.title}>{column.title}</StyledTableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {orderedRows.map( (row, index ) => (
              <TableRow key={index} style={{ backgroundColor: row.backgroundColor }}>
                {columns.map((column, index) =>
                  <TableCell
                    key={index}
                    component="th"
                    scope="row"
                    style={{ paddingLeft: 75 }}
                  >
                    {
                      column.field === null ? '' :
                        column.render ? column.render(row[column.field], row) :
                          row[column.field]
                    }
                  </TableCell>
                )}
              </TableRow>
            )
          )}
          <TableRow>
            {columns.map(col => <TableCell key={col.field}/>)}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
